export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.wp-cardgame.invo.zone/api',
  ENDPOINTS: {
    LOGIN: '/admin/login',
    CARDS: {
      GET_ALL: (page = 1, limit = 20, search = "") =>
        `/admin/cards?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
      ADD: '/admin/card',
      UPDATE: (id) => `/admin/card/${id}`,
      DELETE: (id) => `/admin/card/${id}`
    },
    UPLOAD: {
      CARD_IMAGE: '/admin/upload/card-image'
    }
  }
};
